import { makeStyles } from '@material-ui/styles'

export default makeStyles(_ => ({
  container: {
    display: 'grid',
    gridTemplateColumns: 'auto auto auto',
  },
}))
